import { MouseEvent, Component } from "react";
import { connect, ConnectedComponent } from "react-redux";
import { IStore, State } from "../../DataTypes/storeTypes";
import { Field, reduxForm } from "redux-form";
import { required, email } from "../../../Common/Form/formValidationRules";
import TextInput from "../../../Common/Form/TextInput";
import { getData, DataType } from "../../../Common/localStorageManager";
import { IFormData } from "../../DataTypes/localStorage";
import { IUserDetails } from "../../DataTypes/helperTypes";
import { onLoginSubmit, updateState } from "../../Actions/actions";
import { NewClient } from "./NewClient";
import { Button } from "@powerdiary/components-library/lib";

interface IProps {
    isBusy: boolean;
    errorMessage: string;

    onSubmit(values);
    recover(e: MouseEvent<HTMLAnchorElement>);

    initialValues: any;
    handleSubmit();
}

class Login extends Component<IProps> {
    render() {
        return (
            <>
                <div className="row">
                    <div className="col-12">
                        <form onSubmit={this.props.handleSubmit}>
                            <div className="form-group">
                                <label className="col-form-label">Email</label>
                                <div>
                                    <Field
                                        name="email"
                                        type="email"
                                        component={TextInput}
                                        validate={[required, email]}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="col-form-label">Password</label>
                                <div>
                                    <Field
                                        name="password"
                                        type="password"
                                        component={TextInput}
                                        validate={[required]}
                                    />
                                </div>
                            </div>
                            {this.props.errorMessage && (
                                <div className="alert alert-danger" role="alert">
                                    <div>{this.props.errorMessage}</div>
                                </div>
                            )}
                            <div className="row">
                                <div className="col-12">
                                    <div className="custom-checkbox">
                                        <Field name="rememberMe" type="checkbox" id="remember" component={TextInput} />
                                        <label className="form-check-label" htmlFor="remember">
                                            Remember me
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-3 mb-1">
                                <div className="col-12">
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        size="large"
                                        disabled={this.props.isBusy}
                                        className="btn-block"
                                    >
                                        Log in
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <a onClick={this.props.recover} href="#" className="fsize12">
                            Click here to reset your password
                        </a>
                    </div>
                </div>
                <hr />
                <div className="row mt-4">
                    <div className="col-12">
                        <NewClient />
                    </div>
                </div>
            </>
        );
    }
}

const FormConnected = reduxForm({ form: "loginForm", getFormState: (state: IStore) => state.forms.loginForm })(Login);

const mapStateToProps = (state: IStore, ownProps: IProps): IProps => {
    const storageData = getData<IFormData>(DataType.LoginPage);

    const initialValues = {
        email: storageData ? storageData.login : null,
        rememberMe: storageData ? storageData.rememberMe : false,
    };

    return {
        ...ownProps,
        isBusy: state.common.isBusy,
        errorMessage: state.common.errorMessage,
        initialValues: initialValues,
    };
};

const mapDispatchToProps = (dispatch, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        onSubmit: (values: IUserDetails) => {
            dispatch(onLoginSubmit(values));
        },
        recover: (e) => {
            e.preventDefault();
            dispatch(updateState(State.Recover));
        },
    };
};

export const LoginConnected: ConnectedComponent<typeof FormConnected, any> = connect(
    mapStateToProps,
    mapDispatchToProps
)(FormConnected);
